export default __webpack_public_path__ + "static/media/BrainBreak cards55.bbe25e61.png";